var map = {
	"./bepower.webp": 46345,
	"./gallucci-editore.png": 3689,
	"./limo.png": 7893,
	"./mechit.jpg": 55218,
	"./memorabid-logo.png": 12644,
	"./sailsquare.png": 61265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60395;